module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v("\n              " + _vm._s(_vm.flashMessage) + "\n            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "details"
    }
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.regNo),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Registration No")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.vehicle.regNo),
      expression: "vehicle.regNo",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-transform": "uppercase"
    },
    attrs: {
      "type": "text",
      "maxlength": "13",
      "minlength": "10",
      "name": "regNo",
      "required": "",
      "placeholder": "Registration No"
    },
    domProps: {
      "value": (_vm.vehicle.regNo)
    },
    on: {
      "keydown": _vm.validateRegistration,
      "change": function($event) {
        _vm.$set(_vm.vehicle, "regNo", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "regNo",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Registration no is a required field\n                    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Registration no is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "minlength"
    },
    slot: "minlength"
  }, [_vm._v("\n                      Minimum length of registration no is 10 character\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.capacity),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Capacity (kg)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.vehicle.capacity),
      expression: "vehicle.capacity",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "100",
      "max": "30000",
      "name": "capacity",
      "required": "",
      "placeholder": "Capacity"
    },
    domProps: {
      "value": (_vm.vehicle.capacity)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.vehicle, "capacity", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "capacity",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Capacity is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Capacity is invalid")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "min"
    },
    slot: "min"
  }, [_vm._v("Minimum 100 kg Capacity")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "max"
    },
    slot: "max"
  }, [_vm._v("Maximum 30000 kg Capacity")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.dateCommissioning),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "dateAdded"
    }
  }, [_vm._v("Date of Commissioning")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "required": "",
      "id": "dateCommissioning",
      "lang": "en",
      "name": "dateCommissioning",
      "input-class": "form-control",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.vehicle.dateCommissioning),
      callback: function($$v) {
        _vm.$set(_vm.vehicle, "dateCommissioning", $$v)
      },
      expression: "vehicle.dateCommissioning"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "dateCommissioning",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Date of Commissioning is a required field\n                    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Date of Commissioning is invalid")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.region),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Geographical Area")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicle.region),
      expression: "vehicle.region"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "region"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vehicle, "region", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Select G.A")]), _vm._v(" "), _vm._l((_vm.region_list), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                      " + _vm._s(item.value) + "\n                    ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "region",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Geographical Area is a required field\n                    ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.ownerName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Transporter Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.vehicle.ownerName),
      expression: "vehicle.ownerName",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "ownerName",
      "required": "",
      "placeholder": "Transporter Name"
    },
    domProps: {
      "value": (_vm.vehicle.ownerName)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.vehicle, "ownerName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "ownerName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Transporter name is a required field\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.ownerContact),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Transporter Contact No.")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.vehicle.ownerContact),
      expression: "vehicle.ownerContact",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "name": "ownerContact",
      "required": "",
      "placeholder": "Transporter contact number",
      "pattern": "[78965][0-9]{9}"
    },
    domProps: {
      "value": (_vm.vehicle.ownerContact)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.vehicle, "ownerContact", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "ownerContact",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Transporter contact no. is a required field\n                    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("\n                      Transporter contact no. is invalid\n                    ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.transportSupervisorName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Transport Supervisor Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.vehicle.transportSupervisorName),
      expression: "vehicle.transportSupervisorName",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "transportSupervisorName",
      "required": "",
      "placeholder": "Transport Supervisor Name"
    },
    domProps: {
      "value": (_vm.vehicle.transportSupervisorName)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.vehicle, "transportSupervisorName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "transportSupervisorName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Supervisor Name is a required field\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.transportSupervisorContact),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Transport Supervisor Contact")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.vehicle.transportSupervisorContact),
      expression: "vehicle.transportSupervisorContact",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "name": "transportSupervisorContact",
      "required": "",
      "placeholder": "Transport Supervisor Contact",
      "pattern": "[78965][0-9]{9}"
    },
    domProps: {
      "value": (_vm.vehicle.transportSupervisorContact)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.vehicle, "transportSupervisorContact", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "transportSupervisorContact",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Supervisor Contact is a required field\n                    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("\n                      Supervisor Contact no. is invalid\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.ownerDetails)
  }, [_c('label', [_vm._v("Transporter Address")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.vehicle.ownerDetails),
      expression: "vehicle.ownerDetails",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "ownerDetails",
      "placeholder": "Other Info"
    },
    domProps: {
      "value": (_vm.vehicle.ownerDetails)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.vehicle, "ownerDetails", $event.target.value)
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.permitDetails)
  }, [_c('label', [_vm._v("Permit Details")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.vehicle.permitDetails),
      expression: "vehicle.permitDetails",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "permitDetails",
      "placeholder": "Permit Details"
    },
    domProps: {
      "value": (_vm.vehicle.permitDetails)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.vehicle, "permitDetails", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.billingInfo)
  }, [_c('label', [_vm._v("Billing Info")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.vehicle.billingInfo),
      expression: "vehicle.billingInfo",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "billingInfo",
      "placeholder": "Billing Info"
    },
    domProps: {
      "value": (_vm.vehicle.billingInfo)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.vehicle, "billingInfo", $event.target.value)
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.otherInfo)
  }, [_c('label', [_vm._v("Other Info")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.vehicle.otherInfo),
      expression: "vehicle.otherInfo",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "name": "otherInfo",
      "placeholder": "Other Info"
    },
    domProps: {
      "value": (_vm.vehicle.otherInfo)
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.vehicle, "otherInfo", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.status),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicle.status),
      expression: "vehicle.status"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vehicle, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "active"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "inactive"
    }
  }, [_vm._v("Inactive")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "status",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Status is a required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Status date is invalid")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label'), _vm._v(" "), _c('div', {
    staticClass: "mt"
  }, [_c('validate', {
    staticClass: "form-group inline",
    class: _vm.fieldClassName(_vm.formstate.cgpsMonitoring)
  }, [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.vehicle.camera),
      expression: "vehicle.camera",
      modifiers: {
        "lazy": true
      }
    }],
    attrs: {
      "type": "checkbox",
      "value": "false",
      "name": "camera"
    },
    domProps: {
      "checked": _vm.vehicle.camera,
      "checked": Array.isArray(_vm.vehicle.camera) ? _vm._i(_vm.vehicle.camera, "false") > -1 : (_vm.vehicle.camera)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.vehicle.camera,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "false",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.vehicle, "camera", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.vehicle, "camera", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.vehicle, "camera", $$c)
        }
      }
    }
  }), _vm._v("Camera")])]), _vm._v(" "), _c('validate', {
    staticClass: "form-group inline",
    class: _vm.fieldClassName(_vm.formstate.camera)
  }, [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.vehicle.cgpsMonitoring),
      expression: "vehicle.cgpsMonitoring",
      modifiers: {
        "lazy": true
      }
    }],
    attrs: {
      "type": "checkbox",
      "value": "false",
      "name": "cgpsMonitoring"
    },
    domProps: {
      "checked": _vm.vehicle.cgpsMonitoring,
      "checked": Array.isArray(_vm.vehicle.cgpsMonitoring) ? _vm._i(_vm.vehicle.cgpsMonitoring, "false") > -1 : (_vm.vehicle.cgpsMonitoring)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.vehicle.cgpsMonitoring,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "false",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.vehicle, "cgpsMonitoring", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.vehicle, "cgpsMonitoring", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.vehicle, "cgpsMonitoring", $$c)
        }
      }
    }
  }), _vm._v("GPS Monitoring")])])], 1)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: ([
        _vm.USER_ROLES.ADMIN,
        _vm.USER_ROLES.SUPER_ADMIN,
        _vm.USER_ROLES.GA_HEAD,
        _vm.USER_ROLES.JOURNEY_MANAGER ]),
      expression: "[\n              USER_ROLES.ADMIN,\n              USER_ROLES.SUPER_ADMIN,\n              USER_ROLES.GA_HEAD,\n              USER_ROLES.JOURNEY_MANAGER,\n            ]",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Vehicle'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n                Cancel\n              ")])]), _vm._v(" "), _c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid)
    },
    on: {
      "click": _vm.createVehicle
    }
  }, [_vm._v("\n              Add Vehicle\n            ")])], 1)], 1)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-788f7aff", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-788f7aff"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/vehicles/VehicleCreate.vue
// module id = 2351
// module chunks = 0